import { render, staticRenderFns } from "./OpenQuestionInput.vue?vue&type=template&id=150b39e2&scoped=true&"
import script from "./OpenQuestionInput.vue?vue&type=script&lang=js&"
export * from "./OpenQuestionInput.vue?vue&type=script&lang=js&"
import style0 from "./OpenQuestionInput.vue?vue&type=style&index=0&id=150b39e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150b39e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
